type ChatIsTypingProps = {
  isTyping: boolean;
}

const ChatIsTyping: React.FC<ChatIsTypingProps> = ({ isTyping }) => {
  if (!isTyping) return null;

  return (
    <div className="flex justify-center items-center w-8 h-[18px] bg-[#F6F8F9] rounded-full">
      <div className="flex gap-[2px] items-center">
        <span className="w-1 h-1 bg-black rounded-full animate-pulse [animation-duration:1.4s] [animation-delay:0s]"></span>
        <span className="w-1 h-1 bg-black rounded-full animate-pulse [animation-duration:1.4s] [animation-delay:0.2s]"></span>
        <span className="w-1 h-1 bg-black rounded-full animate-pulse [animation-duration:1.4s] [animation-delay:0.4s]"></span>
      </div>
    </div>
  )
}

export default ChatIsTyping;